export const BurgerTheme = {
  line: 'palette.tertiary.80',
};
